<template>
    <div class="shops">
        <div class="main">
            <h2>{{languageStrings['Die ganze Shoppingcity auf einen Blick']}}</h2>
            <div class="flex-row">
                <div class="newshops">
                    <h3 class="capitalise">{{languageStrings['neue']}} Shops</h3>
                    <router-link class="button" :to="{name: 'Shops', params: { filter: 'new', filterValue: true, headline: 'Neu Shops' }}">{{languageStrings['neue']}}</router-link>
                </div>
                <div class="alphabet">
                    <h3>Shops {{languageStrings['von']}} A–Z</h3>
                    <router-link v-for="filter in alphafilters" v-bind:key="filter.value" :to="{name: 'Shops', params: { filter: 'alpha', filterValue: filter.value }}" class="button">{{filter.name}}</router-link>
                </div>
                <div class="haus">
                    <h3>Shops {{languageStrings['je Haus']}}</h3>
                    <router-link v-for="filter in hausfilters" v-bind:key="filter.value" :to="{name: 'Shops', params: { filter: 'house', filterValue: filter.value }}" class="button">{{filter.name}}</router-link>
                </div>
            </div>
            <div class="flex-row">
                <div class="branches">
                    <h3>Shops {{languageStrings['nach Branchen']}}</h3>
                    <router-link v-for="filter in store.categories" v-bind:key="filter.name" :to="{name: 'Shops', params: { filter: 'category', filterValue: filter.term_id }}" class="button">{{currentLanguage == 'de' ? filter.name : filter.nameEN}}</router-link>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import { store } from '@/store.js';
    import Advertising from "../../components/Advertising";

    export default {
        name: 'ShopFinder',
        components: {
            Advertising,
        },

        data: function(){
            return {
                alphafilters: [
                    { name: 'A-B', value: 'aäb' },
                    { name: 'C-E', value: 'cde' },
                    { name: 'F-G', value: 'fg' },
                    { name: 'H-J', value: 'hij' },
                    { name: 'K-M', value: 'klm' },
                    { name: 'N-P', value: 'noöp' },
                    { name: 'Q-S', value: 'qrs' },
                    { name: 'T-U', value: 'tüu' },
                    { name: 'V-X', value: 'vwx' },
                    { name: 'Y-Z', value: 'yz' },

                ],
                hausfilters: [
                    { name: '1', value: 1 },
                    { name: '3', value: 3 },
                    { name: '5', value: 5 },
                    { name: '7', value: 7 },
                    { name: '9', value: 9 },
                ],
                // categories: store.state.categories
            }
        },
        mounted() {
            // this.categories = store.state.categories
        },
        props: ['store', 'location', 'languageStrings', 'currentLanguage']
    }
</script>

<style scoped lang="scss">
    @import "../../styles/variables";
    .shops {
        padding-left: $advertisingPadding;

        @include portrait(){
            padding-left: 0px;
        }
    }

    @include portrait(){
        .advertising {
            display: none !important;
        }
    }

    .flex-row {

        @include portrait(){
            flex-wrap: wrap;
        }

        > div {
            display: flex;
            flex-wrap: wrap;
            h3 {
                width: 100%;
            }
        }
    }

    h2 {
        max-width: 80%;
    }

    .button {
        @include buttonActive;
    }

    .newshops {
        @include portrait(){
            width: 30%;
        }
    }

    .alphabet {
        width: 43%;

        @include portrait(){
            width: 70%;
        }
    }
    .haus {
        width: 25%;

        @include portrait(){
            width: 100%;
        }

        a {
            color: white;
        }
        a:nth-child(2) {
            background: $blue;
        }
        a:nth-child(3) {
            background: $green;
        }
        a:nth-child(4) {
            background: $purple;
        }
        a:nth-child(5) {
            background: $yellow;
        }
        a:nth-child(6) {
            background: $rose;
        }
    }

    .newshops {
        .button {
            width: 169px;
            height: 157px;
        }
    }

    .branches {
        max-width: 90%;

        .button {
            padding: 17px 76px;
            @include portrait(){
                padding: 17px 40px;
            }
        }
    }

    .alphabet, .haus {
        .button {
            width: 77px;
            height: 70px;
        }
    }

</style>


